import { useQuery } from "@tanstack/react-query";
import UseApiUser from "./UseApiUser";
import PageParams from "../interfaces/pageParams";

const usePagedUser = (params: PageParams) => {
    const { pagedUser } = UseApiUser();

    return useQuery({
        queryKey: ["users", "paged", params],
        queryFn: () => pagedUser({ ...params }),
        staleTime: 1000 * 60 * 5,
        placeholderData: (previousData) => previousData,
    });
};

export default usePagedUser;
